import React, { useEffect, useState } from 'react';
import api from '../utils/axios';
import { FileDown, History, PlusCircle } from 'lucide-react';
import { NuevoPedido } from '../components/exportmov/NuevoPedido';
import { HistorialPedidos } from '../components/exportmov/HistorialPedidos';

const Tab = ({ activo, onClick, icon: Icon, children, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className={`px-4 py-2 rounded-lg text-sm font-semibold flex items-center gap-1.5 transition-colors ${activo ? 'bg-blue-700 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}
  >
    <Icon className="h-4 w-4" />{children}
  </button>
);

export default function ExportarMovimientos() {
  const [tab, setTab] = useState('nuevo');
  const [config, setConfig] = useState({ motivos: [], historica_conectada: false, corte: '2026-01-01' });
  const [destacado, setDestacado] = useState(null);

  useEffect(() => {
    api.get('/export-movimientos/motivos').then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-6 lg:p-8 pt-20 sm:pt-6 lg:pt-8 max-w-7xl mx-auto" data-testid="exportar-movimientos-page">
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2.5 rounded-xl bg-blue-700/10"><FileDown className="h-6 w-6 text-blue-700" /></div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white">Exportar Movimientos</h1>
          <p className="text-sm text-slate-500">Movimientos de un CUIT o CVU en un período, en Excel o PDF, con registro de cada pedido</p>
        </div>
      </div>
      <div className="flex gap-2 mb-5">
        <Tab activo={tab === 'nuevo'} onClick={() => setTab('nuevo')} icon={PlusCircle} testid="expmov-tab-nuevo">Nuevo pedido</Tab>
        <Tab activo={tab === 'historial'} onClick={() => setTab('historial')} icon={History} testid="expmov-tab-historial">Historial de pedidos</Tab>
      </div>
      <div className={tab === 'nuevo' ? '' : 'hidden'}>
        <NuevoPedido config={config} onCreado={(id) => { setDestacado(id); setTab('historial'); }} />
      </div>
      {tab === 'historial' && <HistorialPedidos motivos={config.motivos} destacado={destacado} />}
    </div>
  );
}
